module.exports = __webpack_public_path__ + "img/right-up-arrow.c04c5f5c.svg";